import {Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Text, Icon} from "@chakra-ui/react";
import React from "react";
import PropTypes from "prop-types";
import { FaCircleExclamation } from "react-icons/fa6";
import { Link } from "@chakra-ui/react"

const SearchHistoryLimitationModal = ({ open, onClose, message }) => {
  return (
    <Modal isOpen={open} onClose={onClose} size={"lg"} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader alignItems={"center"} justifyContent={"start"} gap={2} flexDirection={"row"} display={"flex"}>
          <Icon as={FaCircleExclamation} color={"red.500"} />
          <Text>Your search history limit</Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {message ? (
            <Text mb={2}>
              You&apos;ve reached the saved search limit for this browser.{' '}
              <Link href="/login" fontWeight={600} textDecoration={"underline"} _hover={{ textDecoration: "none" }}>Log in</Link>{' '}
              or{' '}
              <Link href="/register" fontWeight={600} textDecoration={"underline"} _hover={{ textDecoration: "none" }}>register</Link>{' '}
              to sync searches to your account (optional).
            </Text>
          ) : (
            <>
              <Text mb={1}>
                You’ve reached your limit of 6 saved properties.
              </Text>
              <Text mb={1}>
                To view a new property, please remove one from your list.
              </Text>
            </>
          )}

        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

SearchHistoryLimitationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.bool,
};

export default SearchHistoryLimitationModal;